


















































































































































































import { Component, Vue, Provide, Watch, Prop } from "vue-property-decorator";
import JSONBig from 'json-bigint'
import {
  localGet,
  timeFormatDay,
  timeFormatSecond,
  timeFormat,
  setMetaData,
  downloadFile,
} from "@/utils/index";
@Component({
  name: "loanInfo",
  filters: {
    filterTime(time: number) {
      function addZero(val: any) {
        if (val < 10) {
          val = "0" + val;
        }
        return val;
      }
      if (!time) {
        return time;
      }
      let date: any = new Date(time);
      let month: any = addZero(date.getMonth() + 1);
      let day: any = addZero(date.getDate());
      var yearMonthDay = date.getFullYear() + "-" + month + "-" + day;
      var hoursMS =
        addZero(date.getHours()) +
        ":" +
        addZero(date.getMinutes()) +
        ":" +
        addZero(date.getSeconds());
      return yearMonthDay + " " + hoursMS;
    },
  },
})
export default class loanInfo extends Vue {
  @Prop() orderStatus: any;
  @Prop() isBadDebts: any;
  @Prop() borrowCode: any;
  @Prop() onCopy: any;
  @Prop() onError: any;
  @Prop() ticketData: any;
  @Prop() repaymentDate: any;
  @Prop() repaymentMoney: any;
  @Prop() overdueDays: any;
  @Prop() hasRepaymentMoney: any;
  @Prop() billAllMoney: any;
  @Prop() extitemList: any;
  @Prop() repayInfo: any;
  @Prop() isShowLetter: any;
  @Prop() querytype: any;
  @Prop() country: any;
  @Prop() warningLetterList: any;
  @Prop() isdownUrgeLetterDone: any;
  @Prop() caselevel: any;
  @Prop() UrgeLetterEnable: any; //非循环贷是否展示律师函1展示2不展示
  @Prop() DisburseProof: any;
  // ordertagsMap
  @Prop() ordertagsMap: any;
  @Provide() private isUrgeLetterListDone: boolean = false; // 是否获取过下载催收函
  
  //   @Provide() isUrgeLetterListDone: any;

  @Provide() urgeLetterId: any = ""; // 催收函id
  @Provide() urgeLetterList: any = ""; // 催收函id
  //   @Provide() : boolean = false;

  //下載
  private downloadUrgeLetter() {
    this.$emit("downloadUrgeLetter", {
      item: PointerEvent,
      val: this.urgeLetterId,
    });
  }
  //  下载警告信列表
  private downloadWarningLetter(item: any) {
    this.$emit("downloadWarningLetter", {
      item: item,
      //   val: this.urgeLetterId,
    });
  }
  //  发送警告信列表
  private sendWarningLetter(item: any) {
    this.$emit("sendWarningLetter", {
      item: item,
      //   val: this.urgeLetterId,
    });
  }
  // 切换催收函模板
  private getUrgeLetterOptions(val: any) {
    if (!this.isUrgeLetterListDone) {
      this.getUrgeLetterMap();
      this.isUrgeLetterListDone = true;
    }
  }
  // 获取催收函列表
  private async getUrgeLetterMap() {
    const {
      getUrgeLetterMapReqRequest,
      getUrgeLetterMapReq,
    }: any = await import("@/request/urgeLetter");
    let res: any = await getUrgeLetterMapReqRequest.handleHttp(
      getUrgeLetterMapReq({
        Caselevel: this.caselevel,
        Orderid: this.ticketData.orderid,
      }),
      this
    );
    if (res) {
      // this.urgeLetterList1=res.urgelettermapMap
      this.urgeLetterList = res.urgelettermapMap;
    }
  }

  private changeToJson(str) {
    const json = JSONBig({
      storeAsString: true
    })
    try{
      return json.parse(str)
    }catch(err) {
      return str
    }
  }
}
